import { useQuery } from '@tanstack/react-query'
import { workflow } from '../../../../v1'
import { globalQueryKeys } from '../../queryKeys'

export function useReadWorkflow(
  contentId: string | number,
  accountId?: number
) {
  return useQuery({
    queryKey: globalQueryKeys.workflowByContentId(contentId, accountId),
    queryFn: () => workflow.read(contentId, accountId),
    select(res) {
      const users = res.included
        .filter((item) => item.type === 'users')
        .map((user) => ({
          ...user.attributes,
          ...user,
          fullName: user.attributes.transliterated_full_name,
        }))
      const phases = res.included
        .filter((item) => item.type === 'phases')
        .map((phase) => ({
          ...phase.attributes,
          ...phase,
        }))
      return {
        ...res.data.attributes,
        ...res.data,
        users,
        phases,
      }
    },
  })
}
